import { AuthConfig, Auth } from '@foxcorp/foxkit-auth-js/esm';
import Cookies from 'universal-cookie';
import { createApiTokenHandler } from './Api/RefreshTokenHandler';
import { getDefaultConfig } from './Store';
import { mapEnvironment } from './ProfileSDK';
import { signOut } from 'State/User';
import { cookieManager } from './CookieManager';
import { getCookieDomain, getCookieName } from './AuthStore';
import { initUserState } from 'State/store';

//Helpers related to AuthSDK which is generally for MVPD

const cookies = new Cookies();

let auth = {};

const apisIncludedInRefreshTokenHandling = [
  'getAdobeRegCode',
  'checkAdobeAuthN',
  'getEntitlements',
  'getUserMetadata',
  'logoutOfMVPD',
];

export const authSDK = () => {
  if (!Object.keys(auth).length) {
    createAuthInstance();
  }
  return auth;
};

export const createAuthInstance = (accessToken) => {
  const { appVersion, appEnv, authClientId, accountApiKey, foxApi, deviceIdCookieName } = getDefaultConfig();

  const config = {
    apiKey: accountApiKey, // your api key
    baseUrl: foxApi,
    clientId: authClientId,
    environment: mapEnvironment(appEnv), // development, qa, staging, production
    dcgUdid: cookies.get(deviceIdCookieName), //optional deviceId
    appName: 'fox-nation-commerce', // required - your app name, e.g. 'Fox Now',
    appVersion, // required - your app version
    httpClientTimeout: 10000, // the number of milliseconds before an http request times out
    useEksEndPoints: false,
    isSsr: typeof window === 'undefined',
    ...(accessToken ? { accessToken } : {}),
    statefulRefreshToken: {
      useHydraForRefresh: true,
      cookieManager: cookieManager(),
      authCookieDomain: getCookieDomain(),
      authCookieName: getCookieName(),
      onRefreshSuccess: () => {
        initUserState();
      },
      onRefreshError: (error) => {
        console.error('[AuthSDK][core] onRefreshError', error);

        if (typeof window !== 'undefined') {
          signOut(true);
        }
      },
      use: true,
    },
  };

  for (const key of Object.getOwnPropertyNames(Auth.prototype)) {
    if (apisIncludedInRefreshTokenHandling.includes(key)) {
      const originalMethod = Auth.prototype[key];
      Auth.prototype[key] = function () {
        return createApiTokenHandler(() => originalMethod.apply(this, arguments));
      };
    }
  }

  const authConfig = new AuthConfig(config);
  auth = new Auth(authConfig);
};
